import { render, staticRenderFns } from "./InfluenceIcon.vue?vue&type=template&id=22d5ab35&scoped=true&"
import script from "./InfluenceIcon.vue?vue&type=script&lang=js&"
export * from "./InfluenceIcon.vue?vue&type=script&lang=js&"
import style0 from "./InfluenceIcon.vue?vue&type=style&index=0&id=22d5ab35&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d5ab35",
  null
  
)

export default component.exports